module.exports = __webpack_public_path__ + "static/media/background.9d4ff6cb.svg";